/**
 * Core Web Vitals monitoring.
 * Reports LCP, INP, CLS, FCP, and TTFB.
 * - Dev: logs to console
 * - Prod: logs to console (swap with analytics endpoint when ready)
 */
import type { Metric } from 'web-vitals';

function reportMetric(metric: Metric) {
  if (import.meta.env.DEV) {
    const label = `[Web Vital] ${metric.name}`;
    const value = metric.name === 'CLS' ? metric.value.toFixed(4) : `${Math.round(metric.value)}ms`;
    console.log(`${label}: ${value} (rating: ${metric.rating})`);
    return;
  }

  // Production: log for now. Replace with analytics endpoint when available.
  // Example: navigator.sendBeacon('/api/vitals', JSON.stringify(metric));
  console.log(`[Web Vital] ${metric.name}: ${metric.value} (${metric.rating})`);
}

export function initWebVitals() {
  // Dynamic import so web-vitals is tree-shaken and loaded lazily
  import('web-vitals').then(({ onLCP, onINP, onCLS, onFCP, onTTFB }) => {
    onLCP(reportMetric);
    onINP(reportMetric);
    onCLS(reportMetric);
    onFCP(reportMetric);
    onTTFB(reportMetric);
  });
}
